import { StatsEntry } from "./types";

export const EMPTY = "Empty";
export const GAP = "Gap";
export const LOADING = "Loading";
export const TRANSPARENT_COLOR = "transparent";

export const EMPTY_STATE: StatsEntry[] = [{ name: EMPTY, count: 1 }];
export const LOADING_STATE: StatsEntry[] = [{ name: LOADING, count: 1 }];
